import {OptimizationSpecialistPlantDashboard} from '@features/optimization-specialist-dashboard'
import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useParams, useNavigate} from 'react-router'

import {useTrackOptimizationSpecialistAnalyticsEvent} from '../../../performanceDashboard/helpers/trackAnalyticsEvents'
import {OptimizationSpecialistEventName} from '../../../performanceDashboard/helpers/trackOptimizationSpecialistEvents'
import {useTranslationPrefix} from '../../../shared/hooks'
import {LocationBreadcrumbs} from '../../components'
import {useOptimizationSpecialistTimeRange} from '../../hooks'
import {
  generateCockpitShiftSummaryLink,
  getOptimizationSpecialistPerformancePagePath,
  getOptimizationSpecialistStoppageAnalysisPagePath
} from '../../utils'

type PathParameter = {
  plantId?: string
}

export const OptimizationSpecialistDashboard = () => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const {t} = useTranslation()
  const navigate = useNavigate()
  const {hrocPrefix} = useTranslationPrefix()

  const redirectToStoppageAnalysis = (equipmentId: string) => {
    void navigate(getOptimizationSpecialistStoppageAnalysisPagePath(plantId, equipmentId, 'today'))
  }

  const trackOptimizationSpecialistDashboard = useTrackOptimizationSpecialistAnalyticsEvent()
  useEffect(() => {
    trackOptimizationSpecialistDashboard(
      OptimizationSpecialistEventName.UserEntersOptimizationSpecialist,
      {}
    )
  }, [trackOptimizationSpecialistDashboard])

  const {rawTimeRange} = useOptimizationSpecialistTimeRange()
  const cockpitHref = generateCockpitShiftSummaryLink(rawTimeRange, plantId)
  const optimizationSpecialistPerformanceHref = getOptimizationSpecialistPerformancePagePath(
    plantId,
    'yesterday'
  )

  return (
    <OptimizationSpecialistPlantDashboard
      plantId={plantId}
      titleSlot={t(`${hrocPrefix}.optimizationSpecialistDashboard.pageTitle`)}
      aboveTitleSlot={<LocationBreadcrumbs sx={{ml: 0}} />}
      cockpitHref={cockpitHref}
      optimizationSpecialistPerformanceHref={optimizationSpecialistPerformanceHref}
      onEquipmentClick={redirectToStoppageAnalysis}
    />
  )
}
